<template>
	<div class="section-testimonials padding-top-70 padding-bottom-70">
		<section-title component-class="margin-bottom-50">
			<h2>
				{{ $t('Section.TestimonialsContainerSentence1') }}
			</h2>
		</section-title>

		<div class="container">
			<div class="row">
				<div class="col-xs-12 text-center">
					<ul class="list-none display-inline testimonials-list">
						<testimonials-container-box
							v-for="(value, key) in testimonials"
							v-once
							:key="key"
							:item="value"
						></testimonials-container-box>
					</ul>
          <div id="testimonials-nav" class="testimonials-nav"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Config from '@/config'
import TestimonialsContainerBox from '@/components/sections/boxes/TestimonialsContainerBox'
import SectionTitle from '@/components/partials/SectionTitle'

export default {
	name: 'TestimonialsContainer',
	components: {
		TestimonialsContainerBox,
		SectionTitle,
	},
  data() {
		return {
			testimonials: Config.TESTIMONIALS,
		}
	},
}
</script>



// WEBPACK FOOTER //
// src/components/sections/TestimonialsContainer.vue